import { API_ENDPOINT } from './config';


export const urlsTranslation = {
  translate: `${API_ENDPOINT}/translate`,
  traslationProviders: `${API_ENDPOINT}/translate/providers`,
  providerUsage: `${API_ENDPOINT}/translate/usage`,
};

export const routesTranslation = {



}
